module.exports = __webpack_public_path__ + "img/20200623-4.c53a90d2.jpg";